export const services = [
  {
    id: 1,
    titulo: { pt: "Consultas e orientação", en: "Consultations and guidance", es: "Consultas y orientación",fr: "Consultations et orientation",it: "Consulenze e orientamento",de: "Beratung und Orientierung", zh: "咨询与指导"
  },
    descri: {
    pt: "Prestamos consultoria especializada para encontrar a solução ideal para cada necessidade elétrica e de iluminação.",
    en: "We provide specialized consulting to find the ideal solution for each electrical and lighting need.",
    es: "Brindamos consultoría especializada para encontrar la solución ideal para cada necesidad eléctrica y de iluminación.",
    fr: "Nous offrons un service de conseil spécialisé pour trouver la solution idéale à chaque besoin électrique et d'éclairage.",
    it: "Forniamo consulenza specializzata per trovare la soluzione ideale per ogni esigenza elettrica e di illuminazione.",
    de: "Wir bieten spezialisierte Beratung, um die ideale Lösung für jeden elektrischen und beleuchtungstechnischen Bedarf zu finden.",
    zh: "我们提供专业咨询，以找到满足每个电气和照明需求的理想解决方案。"
  },
    icon: "fi fi-tr-introduction",
  },
  {
    id: 2,
    titulo:  {pt: "Vantagens para profissionais e revendedores",en: "Benefits for professionals and resellers",es: "Ventajas para profesionales y revendedores", fr: "Avantages pour les professionnels et revendeurs",
    it: "Vantaggi per professionisti e rivenditori",
    de: "Vorteile für Fachleute und Wiederverkäufer",
    zh: "专业人士和经销商的优势"
    },
    descri: {
    pt: "Oferecemos vantagens comerciais para quem trabalha com revenda ou para profissionais de um setor específico.",
    en: "We offer commercial benefits for those working in resale or for professionals in a specific sector.",
    es: "Ofrecemos ventajas comerciales para quienes trabajan con reventa o para profesionales de un sector específico.",
    fr: "Nous offrons des avantages commerciaux à ceux qui travaillent dans la revente ou aux professionnels d'un secteur spécifique.",
    it: "Offriamo vantaggi commerciali a chi lavora nella rivendita o a professionisti di un settore specifico.",
    de: "Wir bieten kommerzielle Vorteile für alle, die im Wiederverkauf tätig sind oder für Fachleute in einem bestimmten Sektor.",
    zh: "我们为从事转售业务或特定行业的专业人士提供商业优惠。"
  },
    icon: "fi fi-ts-trust-alt",
  },
  {
    id: 3,
    titulo: { pt: "Serviço de vendas", en: "Sales service", es: "Servicio de ventas", fr: "Service de vente",it: "Servizio vendite",de: "Verkaufsservice",zh: "销售服务"},
    descri: {
    pt: "Na Iberolec, a experiência de compra é simples, rápida e confiável, sempre com produtos de qualidade.",
    en: "At Iberolec, the shopping experience is simple, fast, and reliable, always with quality products.",
    es: "En Iberolec, la experiencia de compra es simple, rápida y confiable, siempre con productos de calidad.",
    fr: "Chez Iberolec, l'expérience d'achat est simple, rapide et fiable, toujours avec des produits de qualité.",
    it: "In Iberolec, l'esperienza di acquisto è semplice, veloce e affidabile, sempre con prodotti di qualità.",
    de: "Bei Iberolec ist das Einkaufserlebnis einfach, schnell und zuverlässig, immer mit Qualitätsprodukten.",
    zh: "在 Iberolec，购物体验简单、快捷、可靠，并始终保证高质量产品。"
  },
    icon: "fi fi-ts-supplier-alt",
  },
]